import "./_Footer.scss"

const Footer = () => {
    return (
        <div className="footer-container">
            <p>Vous avez un projet audiovisuel ?</p><a href="mailto:arthurlemeur.music@gmail.com">Contactez-moi</a>
        </div>
    )
}

export default Footer;